import { LocationContext } from "../nav/pageChooser"
import { useContextWithGuard } from "../helpers/useContextWithGuard";
import { Course } from "../nav/courses";
import { topics } from "../nav/topics";
import { AutoWidthSelect } from "./autoWidthSelect";
import { useIsMobile } from "../device/useIsMobile";
import { Stack } from "@mui/material";
import { IQuestion } from "../types";
import { Slash } from "./slash";

interface NavMenuProps {
    setCursor: (c: IQuestion | null) => void
}

export const NavMenu = (props: NavMenuProps) => {
    const { course, setCourse,
        topic, setTopic,
        subTopic, setSubTopic,
        subSubTopic, setSubSubTopic } = useContextWithGuard(LocationContext, "LocationContext");
    const isMobile = useIsMobile();

    const courseChange = (value: string) => {
        props.setCursor(null);
        setSubSubTopic("Subsubtopic");
        setSubTopic("Subtopic");
        setTopic("Topic");
        setCourse(value as Course)
    }

    const topicChange = (value: string) => {
        props.setCursor(null);
        setSubSubTopic("Subsubtopic");
        setSubTopic("Subtopic");
        setTopic(value);
    }

    const subTopicChange = (value: string) => {
        props.setCursor(null);
        setSubSubTopic("Subsubtopic");
        setSubTopic(value);
    }

    const subSubTopicChange = (value: string) => {
        props.setCursor(null);
        setSubSubTopic(value);
    }

    return (
        <Stack direction="row" sx={{flexWrap: isMobile ? "wrap" : "nowrap"}}>
            <AutoWidthSelect
                values={Object.values(Course)}
                selected={course}
                setSelected={courseChange}
            />
            {
                course &&
                <>
                    {
                        !isMobile && <Slash />
                    }
                    <AutoWidthSelect
                        values={["Topic", ...Object.keys(topics[course])]}
                        selected={topic}
                        setSelected={topicChange}
                    />
                </>
            }
            {
                course && topic != "Topic" &&
                <>
                    {
                        !isMobile && <Slash />
                    }
                    <AutoWidthSelect
                        values={["Subtopic", ...Object.keys(topics[course][topic])]}
                        selected={subTopic}
                        setSelected={subTopicChange}
                    />
                </>
            }
            {
                course && topic != "Topic" && subTopic != "Subtopic" &&
                <>
                    {
                        !isMobile && <Slash />
                    }
                    <AutoWidthSelect
                        values={["Subsubtopic", ...Object.values(topics[course][topic][subTopic])]}
                        selected={subSubTopic}
                        setSelected={subSubTopicChange}
                    />
                </>
            }
        </Stack>
    )
}